<template>
  <ValidationObserver ref="notesPage" id="notesPage" name="notesPage">
    <div v-if="loadingNotes" class="text-center font-size-h2">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-if="!loadingNotes && (!Array.isArray(allNotes) || allNotes.length === 0)">
      <div class="form-group">
        <h4 class="text-center">No data available.</h4>
      </div>
    </div>

    <div v-if="!loadingNotes && Array.isArray(allNotes) && allNotes.length > 0">

      <div class="d-flex justify-content-end">
        <button class="btn btn-outline-primary btn-sm" @click.prevent="toggleSortOrder">
          <span v-if="sortOrder === 'desc'">
            <i class="fa fa-sort-amount-up"></i>
            Sort Ascending
          </span>
          <span v-if="sortOrder === 'asc'">
            <i class="fa fa-sort-amount-down"></i>
            Sort Descending
          </span>
        </button>
      </div>

      <table class="table table-sm table-hover">
        <thead>
          <th width="10%" class="text-center"></th>
          <th width="90%" class="text-center"></th>
        </thead>
        <tbody>
          <tr v-for="(note, index) in allNotes" :key="index">
            <td>
              <div class="font-size-h6 font-weight-bold">{{ note.Created_By.name }}</div>
              <div>{{ note.Created_Time_Str }}</div>
            </td>
            <td>
              <b-card body-class="pl-5 pr-5 pb-2 pt-2 bg-light" class="mb-5">
                <b-card-title v-if="note.Note_Title">{{ note.Note_Title }}</b-card-title>
                <b-card-text>
                  <span v-html="note.Note_Content"></span>
                </b-card-text>
              </b-card>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>

import _ from "lodash";

export default {
  name: "NotesPage",

  components: {},

  props: {
    notes: Array,
    loadingNotes: Boolean
  },

  data() {
    return {
      allNotes: this.notes,
      sortOrder: 'desc'
    };
  },

  watch: {
    notes: function(newVal, oldVal) {
      this.allNotes = newVal;
    }
  },

  computed: {
  },

  methods: {
    toggleSortOrder: function () {
      this.sortOrder = (this.sortOrder === 'desc') ? 'asc' : 'desc';
      this.allNotes = _.orderBy(this.allNotes, ['Created_Time'], [this.sortOrder]);
    },
  }
};
</script>
